export default "__VITE_ASSET__DJFnmWJy__"